export default __webpack_public_path__ + "static/media/overlay_background_2.a4b467f7.png";